import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LoggerService } from '../services/logger.service';
import { extractApiErrorMessage } from '../errors/error-message.util';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    map((event: HttpEvent<unknown>) => {
      // If server returned HTTP 200 with { success: false, message: "...", error_code: "..." }
      if (event instanceof HttpResponse) {
        const body = event.body as any;
        if (body && typeof body === 'object' && body.success === false) {
          const errMsg = body.message || 'API Error';
          throw new HttpErrorResponse({
            error: body,
            status: 400,
            statusText: errMsg,
            url: req.urlWithParams
          });
        }
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      // Don't log requests made to the logger API to avoid infinite loops
      if (req.url.includes('logger.abgadhawaz.com') || req.url.includes('logger.efrx.com')) {
        return throwError(() => error);
      }

      const errorMessage = extractApiErrorMessage(error);

      if (error.status === 404) {
        logger.notice(errorMessage, {
          url: req.urlWithParams,
          method: req.method
        });
      } else {
        logger.error(errorMessage, {
          url: req.urlWithParams,
          method: req.method
        });
      }

      return throwError(() => error);
    })
  );
};
